<div class="d-flex flex-column gap-4 p-3 w-100 bg-white">

  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center pb-3 border-bottom border-2">
    <div class="fs-5 fw-bold">Applied Terms and Conditions</div>
    <button class="btn btn-light d-flex align-items-center gap-2" (click)="goTo('/instant-rate-manager')">
      <i class="bi bi-arrow-left"></i>
      Back to Instant Rate Manager
    </button>
  </div>

  <!-- Content -->
  <div class="row g-4">

    <!-- Left: List -->
    <div class="col-12 col-md-5" [class.d-none]="selectedTerm && !isCreatingNew" [class.d-md-block]="selectedTerm && !isCreatingNew">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h5 class="fw-bold mb-0 text-dark">
          Your Terms
          <span class="badge bg-light text-dark ms-2 border fw-normal">
            {{ paginationInfo ? paginationInfo.count : terms.length }}
          </span>
        </h5>
        <button class="btn btn-primary px-4 fw-bold shadow-sm" (click)="openCreateModal()">
          <i class="bi bi-plus-lg me-2"></i> Add New Term
        </button>
      </div>

      <div class="mb-3 d-flex gap-2">
        <div class="position-relative flex-grow-1">
          <i class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
          <input type="text" class="form-control form-control-sm border-0 shadow-sm rounded-pill ps-5 pe-5"
            placeholder="Search terms..." [(ngModel)]="search" (ngModelChange)="termSearch$.next($event)">
          <button *ngIf="search" type="button"
            class="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
            (click)="search = ''; termSearch$.next('')">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <select class="form-select form-select-sm border-0 shadow-sm rounded-pill w-auto"
          [(ngModel)]="sortBy" (ngModelChange)="onSortChange()">
          <option *ngFor="let opt of sortOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </div>

      <div *ngIf="isListLoading" class="text-center py-5">
        <div class="spinner-border text-primary opacity-50" role="status"></div>
        <p class="text-muted mt-2 small">Loading terms...</p>
      </div>

      <div class="d-flex flex-column gap-3" *ngIf="!isListLoading">
        <div *ngFor="let term of terms" (click)="selectTerm(term)"
          class="card border-0 shadow-sm cursor-pointer transition-all"
          [class.border-primary]="selectedTerm?.id === term.id"
          [style.background]="selectedTerm?.id === term.id ? '#f0f7ff' : 'white'">

          <div class="card-body p-3 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center gap-3">
              <div class="rounded-circle p-2"
                [ngClass]="selectedTerm?.id === term.id ? 'bg-primary-subtle text-primary' : 'bg-light text-secondary'">
                <i class="bi bi-file-text fs-5"></i>
              </div>
              <div class="d-flex flex-column">
                <span class="fw-bold" [class.text-primary]="selectedTerm?.id === term.id">{{ term.name }}</span>

              </div>
            </div>
            <button class="btn btn-link text-danger p-0 border-0" (click)="deleteTerm(term.id, $event)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>

        <div *ngIf="terms.length === 0" class="text-center py-5 text-muted small">
          No terms found. Click "Add New Term" to get started.
        </div>

        <nav class="mt-5 pb-4" *ngIf="paginationInfo && paginationInfo.total_pages > 1">
          <div class="d-flex justify-content-center align-items-center gap-3">
            <button class="page-link border-0 shadow-sm rounded-circle p-2 bg-white text-primary"
              (click)="onPageChange('prev')" [disabled]="!paginationInfo.previous">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="fw-bold text-dark small">Page {{ paginationInfo.current_page }} of {{ paginationInfo.total_pages }}</span>
            <button class="page-link border-0 shadow-sm rounded-circle p-2 bg-white text-primary"
              (click)="onPageChange('next')" [disabled]="!paginationInfo.next">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </nav>
      </div>
    </div>

    <!-- Right: Detail / Edit -->
    <div class="col-12 col-md-7" [class.d-none]="!selectedTerm && !isCreatingNew" [class.d-md-block]="!selectedTerm && !isCreatingNew">
      <div *ngIf="!selectedTerm && !isCreatingNew"
        class="h-100 d-flex flex-column align-items-center justify-content-center border-2 border-dashed rounded-4 p-5 text-center bg-white opacity-75">
        <div class="bg-light rounded-circle p-4 mb-3">
          <i class="bi bi-file-text fs-1 text-secondary opacity-50"></i>
        </div>
        <h6 class="fw-bold text-dark">No Term Selected</h6>
        <p class="text-muted small">Select a term from the list to view or edit details.</p>
      </div>

      <div *ngIf="selectedTerm && !isCreatingNew" class="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div class="card-header bg-white p-4 border-0 pb-0 d-flex align-items-center gap-2">
          <button class="btn btn-link text-decoration-none text-dark p-0 d-md-none me-2" (click)="cancelEdit()">
            <i class="bi bi-arrow-left fs-4"></i>
          </button>
          <h5 class="fw-bold mb-0 text-dark">Term Details</h5>
        </div>
        <div class="card-body p-4">
          <form class="row g-3" (submit)="saveTerm()">
            <div class="col-12">
              <label class="form-label fw-bold small text-secondary text-uppercase">Title</label>
              <input type="text" class="form-control bg-light border-0 py-2" [(ngModel)]="selectedTerm.name" name="name"
                [class.is-invalid]="isSubmitted && (!selectedTerm.name || !selectedTerm.name.trim())">
              <small *ngIf="isSubmitted && (!selectedTerm.name || !selectedTerm.name.trim())" class="text-danger">Title is required</small>
            </div>
            <div class="col-12">
              <label class="form-label fw-bold small text-secondary text-uppercase">Term Details</label>
              <div [class.summernote-invalid]="isSubmitted && isDescriptionEmpty(selectedTerm.description)">
                <textarea appSummernote [height]="editorHeight" [(ngModel)]="selectedTerm.description" name="description"></textarea>
              </div>
              <small *ngIf="isSubmitted && isDescriptionEmpty(selectedTerm.description)" class="text-danger d-block mt-1">Term Details are required.</small>
            </div>
            <div class="col-12 mt-4 pt-3 border-top d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-light px-4" (click)="cancelEdit()">Cancel</button>
              <button type="submit" class="btn btn-primary px-4 fw-bold shadow-sm" [disabled]="isSaving">
                <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
                Save Term
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</div>

<ng-template #termModalTemplate let-modal>
  <div class="modal-header border-0 pt-4 px-4">
    <h5 class="modal-title fw-bold text-dark">Add New Term</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-4 pt-2">
    <div class="row g-3" *ngIf="selectedTerm">
      <div class="col-12">
        <label class="form-label fw-bold small text-secondary text-uppercase">Title</label>
        <input type="text" class="form-control bg-light border-0 py-2" [(ngModel)]="selectedTerm.name" name="newName"
          [class.is-invalid]="isSubmitted && (!selectedTerm.name || !selectedTerm.name.trim())">
        <small *ngIf="isSubmitted && (!selectedTerm.name || !selectedTerm.name.trim())" class="text-danger">Title is required</small>
      </div>
      <div class="col-12">
        <label class="form-label fw-bold small text-secondary text-uppercase">Term Details</label>
        <div [class.summernote-invalid]="isSubmitted && isDescriptionEmpty(selectedTerm.description)">
          <textarea appSummernote [height]="250" [(ngModel)]="selectedTerm.description" name="newDescription"></textarea>
        </div>
        <small *ngIf="isSubmitted && isDescriptionEmpty(selectedTerm.description)" class="text-danger d-block mt-1">Term Details are required.</small>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 p-4 pt-0 gap-2">
    <button type="button" class="btn btn-light px-4" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary px-4 fw-bold shadow-sm" (click)="saveTerm()" [disabled]="isSaving">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
      Create Term
    </button>
  </div>
</ng-template>
